// extracted by mini-css-extract-plugin
export default {"positionClass":"search_positionClass__K566f","field":"search_field__NBRqt"};